module.exports = __webpack_public_path__ + "static/media/Linkedin.f206288e.svg";